<template>
  <section class="home" v-hammer:swipe="onSwipe">
    <h1 style="visibility: hidden; position: absolute;">
      PSP Production: Elevating Film and Advertising Production Experiences in Portugal and Spain
    </h1>
    <article class="home__video" ref="video">
      <video :src="selectedWork.videoShort" class="videoFront" ref="videoFront" style="" autoplay loop muted
        playsinline></video>
      <video :src="nextWork.videoShort" class="videoBack" ref="videoBack" autoplay loop muted playsinline></video>
    </article>
    <Hero ref="hero" :titleTop="selectedWork.titleTop" :titleBottom="selectedWork.titleBottom"
      :subtitle="selectedWork.subtitle" />
    <div class="home__footer">
      <div class="home__footerLeft">
        <ul class="home__dots">
          <li class="home__dot" :class="work.selected && 'selected'" v-for="work in works" @click="selectVideo"
            :data-id="work.id"></li>
        </ul>
        <button class="home__next hover" @click="goToNext">next</button>
        <router-link to="/works" class="home__worksLink"><span class="hover">all work</span></router-link>
      </div>
    </div>
  </section>
</template>

<script>
import anime from 'animejs';
import Hero from '../components/Hero.vue';

export default {
  name: 'Home',
  components: {
    Hero
  },
  mounted() {
    anime({
      targets: '.home__worksLink span',
      translateX: ["-160%", 0],
      translateZ: 0,
      duration: 1000,
      easing: 'easeInOutCubic',
      delay: 3500
    });
    anime({
      targets: ['.home__dots', '.home__next', '.home__worksLink', '.home__smLink'],
      opacity: [0, 1],
      duration: 1000,
      easing: 'easeInOutCubic',
      delay: function (el, i) {
        return 300 * i + 3000;
      }
    });
    document.querySelector('.home').style.height = window.innerHeight + 'px';
  },
  data() {
    return {
      nextWork: {}
    }
  },
  computed: {
    works() {
      return this.$store.getters.homeWorks;
    },
    selectedWork() {
      return this.$store.getters.selectedWork;
    },
  },
  methods: {
    selectVideo(event) {
      const target = event.target;
      const workId = target.dataset.id;
      const hero = this.$refs.hero.$el;
      this.nextWork = this.works.find(work => work.id === workId);
      this.slideTransition(workId);
    },
    onSwipe(e) {
      if (e.direction === 2) this.goToNext();
      if (e.direction === 4) this.goToPrev();
    },
    goToNext() {
      let currentIndex = this.works.indexOf(this.works.find(work => work.selected)) + 1;
      if (currentIndex >= this.works.length) currentIndex = 0;
      this.nextWork = this.works[currentIndex];
      const workId = this.nextWork.id;
      this.slideTransition(workId);
    },
    goToPrev() {
      let currentIndex = this.works.indexOf(this.works.find(work => work.selected)) - 1;
      if (currentIndex < 0) return;
      this.nextWork = this.works[currentIndex];
      const workId = this.nextWork.id;
      this.slideTransition(workId);
    },
    slideTransition(workId) {
      const hero = this.$refs.hero.$el;
      const video = this.$refs.video;
      const videoBack = this.$refs.videoBack;
      const videoFront = this.$refs.videoFront;
      videoBack.classList.add('stage1');
      hero.style.transform = 'translate(-60%,-50%)';
      hero.style.opacity = 0;
      setTimeout(() => {
        hero.style.transform = 'translate(-35%,-50%)';
        videoBack.classList.remove('stage1');
        videoBack.classList.add('stage2');
      }, 1000)
      setTimeout(() => {
        videoBack.classList.remove('stage2');
        videoBack.classList.add('stage3');
      }, 1200)
      setTimeout(() => {
        this.$store.commit('changeSelectedHomeWork', workId);
        hero.style.transform = 'translate(-50%,-50%)';
        hero.style.opacity = 1;
      }, 1800);
      setTimeout(() => {
        videoFront.currentTime = videoBack.currentTime + .2;
      }, 1900);
      setTimeout(() => {
        videoBack.classList.remove('stage3');
      }, 2400);
    }
  },
}
</script>

<style lang="scss">
@import "../styles/config.scss";

.home {
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  padding: 0;
  margin: 0;

  &__video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    transition: opacity .4s ease-in-out;

    video {
      min-width: 100%;
      min-height: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    &:after {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      background-color: rgba(0, 0, 0, .3);
    }
  }

  &__footer {
    position: absolute;
    bottom: 60px;
    width: 100%;
    max-width: 1240px;
    padding: 0 20px;
    text-align: left;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__footerLeft {
    display: flex;
    align-items: center;
  }

  &__dots {
    //width: 150px;
    margin-right: 60px;
  }

  &__dot {
    border-radius: 5px;
    border: 1px solid var(--Neu01);
    width: 6px;
    height: 6px;
    margin-right: 10px;
    display: inline-block;
    vertical-align: middle;
    transition: border-color .2s ease-in, width .3s ease-in;

    &.selected {
      border-color: var(--M01);
      width: 50px;
      transition: border-color .2s ease-in .3s, width .6s cubic-bezier(.41, .15, .41, 1.31) .2s;
    }
  }

  &__next {
    background-color: transparent;
    border: none;
    margin: 0;
    font-family: CamptonBold;
    font-size: 20px;
    color: var(--Neu01);
    overflow: hidden;
    margin-right: 120px;
  }

  &__worksLink {
    font-family: CamptonBold;
    font-size: 20px;
    color: var(--Neu01);
    overflow: hidden;
    top: -1px;

    em {
      font-style: normal;
    }

    &:before {
      content: url("../assets/viewwork.svg");
      margin-right: 10px;
      top: 3px;
      position: relative;
      opacity: 0;
      animation: playBtn 1s linear 3s forwards;
    }
  }

  .videoBack {
    clip-path: inset(20% 20% 20% 80%);
    transition: all .8s cubic-bezier(0.165, 0.84, 0.44, 1);

    &.stage1 {
      clip-path: inset(20% 20% 20% 20%);
    }

    &.stage2 {
      clip-path: polygon(100% 0, 100% 100%, 100% 100%, 100% 50%, 80% 50%, 80% 80%, 20% 80%, 20% 20%, 80% 20%, 80% 50%, 100% 50%, 100% 0);
    }

    &.stage3 {
      clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 50%, 80% 50%, 80% 80%, 20% 80%, 20% 20%, 80% 20%, 80% 50%, 0 50%, 0 0);
    }
  }

  @include mq(0, 768px) {
    height: calc(100vh - 75px);

    &__footer {
      flex-direction: column;
      align-items: flex-start;
      bottom: 20px;
    }

    &__footerLeft {
      flex-wrap: wrap;
      margin-bottom: 0;
    }

    &__dots {
      margin-right: 20px;
    }

    &__next {
      margin-right: 0;
    }

    &__worksLink {
      width: 100%;
      margin-top: 10px;
    }

    &__footerRight {
      width: 100%;
      text-align: right;
    }

    .videoBack {
      clip-path: inset(30% 41% 30% 59%);
      transition: all .8s cubic-bezier(0.165, 0.84, 0.44, 1);

      &.stage1 {
        clip-path: inset(30% 41% 30% 41%);
      }

      &.stage2 {
        clip-path: polygon(100% 0, 100% 100%, 100% 100%, 100% 50%, 80% 50%, 80% 80%, 20% 80%, 20% 20%, 80% 20%, 80% 50%, 100% 50%, 100% 0);
      }

      &.stage3 {
        clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 50%, 80% 50%, 80% 80%, 20% 80%, 20% 20%, 80% 20%, 80% 50%, 0 50%, 0 0);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/containers/Home.vue